module.exports = __webpack_public_path__ + "static/media/upload_doc.ce262218.svg";